function initHover(el) {
  if (el.__hoverInited) return;

  el.__hoverInited = true;

  const titleItems = el.querySelectorAll('.mega-tab-title-item');
  const contentItems = el.querySelectorAll('.mega-tab-content-item');

  function showContent(content) {
    content.style.display = 'block';
    content.style.opacity = '0';
    content.style.transform = 'translateX(20px)';

    content.classList.add('active');

    requestAnimationFrame(function () {
      content.style.opacity = '1';
      content.style.transform = 'translateX(0)';
    });

    content.addEventListener('transitionend', function handler(event) {
      if (event.propertyName !== 'transform') return;

      content.style.display = '';
      content.style.opacity = '';
      content.style.transform = '';

      content.removeEventListener('transitionend', handler);
    });
  }

  function hideContent(content) {
    content.classList.remove('active');
    content.style.display = 'none';
    content.style.opacity = '';
    content.style.transform = '';
  }

  titleItems.forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      if (item.classList.contains('active')) return;

      const dataId = item.getAttribute('data-id');

      titleItems.forEach(function (title) {
        title.classList.remove('active');
      });

      item.classList.add('active');

      contentItems.forEach(function (content) {
        if (content.id === dataId) {
          showContent(content);
        } else {
          hideContent(content);
        }
      });
    });
  });
};

function initMegaVideo(el) {
  if (el.__initMegaVideo) return;

  el.__initMegaVideo = true;

  el.addEventListener('click', function () {
    if (el.classList.contains('is-playing')) return;

    const videoId = el.getAttribute('data-id');

    if (!videoId) return;

    const img = el.querySelector('img');
    const svg = el.querySelector('svg');

    if (img) img.style.display = 'none';
    if (svg) svg.style.display = 'none';

    const iframe = document.createElement('iframe');

    iframe.className = 'mega_video_iframe';
    iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&controls=1&rel=0&playsinline=1';
    iframe.title = 'YouTube video player';
    iframe.frameBorder = '0';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;

    el.appendChild(iframe);
    el.classList.add('is-playing');
  });
}

function numberCount(el) {
  if (el.__numberCount) return;
  el.__numberCount = true;

  const target = Number(el.dataset.count);
  const duration = Number(el.dataset.duration) || 1500;
  const decimals = Number(el.dataset.decimals) || 0;
  const prefix = el.dataset.prefix || '';
  const suffix = el.dataset.suffix || '';

  function formatNumber(num) {
    return (
      prefix +
      num.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
      suffix
    );
  }

  function startCount() {
    const startTime = performance.now();

    function update(now) {
      const progress = Math.min((now - startTime) / duration, 1);
      const easeProgress = 1 - Math.pow(1 - progress, 3);
      const current = target * easeProgress;

      el.textContent = formatNumber(current);

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        el.textContent = formatNumber(target);
      }
    }

    requestAnimationFrame(update);
  }

  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      startCount();
      observer.disconnect();
    }
  }, {
    threshold: 0.3
  });

  observer.observe(el);
}

const watchList = [
  {
    selector: '.mega-tab-box',
    handler: initHover,
    flag: '__hoverInited'
  },
  {
    selector: '.mega-video',
    handler: initMegaVideo,
    flag: '__initMegaVideo'
  },
  {
    selector: '.custom-count-number',
    handler: numberCount,
    flag: '__numberCount'
  }
];

// 初次加载
watchList.forEach(item => {
  document.querySelectorAll(item.selector).forEach(node => {
    if (item.flag && node[item.flag]) return;
    item.handler(node);
  });
});

// 统一 MutationObserver 监听
let moTimer = null;

const observer = new MutationObserver(() => {
  clearTimeout(moTimer);
  moTimer = setTimeout(() => {
    watchList.forEach(item => {
      document.querySelectorAll(item.selector).forEach(node => {
        if (item.flag && node[item.flag]) return;
        item.handler(node);
      });
    });
  }, 50);
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

document.addEventListener('DOMContentLoaded', function () {
  const article = document.querySelector('.t4s-article-content');

  if (!article || article.dataset.tocInitialized === 'true') return;

  const headings = Array.from(article.querySelectorAll('h2, h3'))
    .filter(heading => heading.textContent.trim());

  if (!headings.length) return;

  article.dataset.tocInitialized = 'true';

  // 创建目录
  const toc = document.createElement('nav');
  toc.className = 'article-toc';
  toc.setAttribute('aria-label', 'Table of Contents');

  const title = document.createElement('div');
  title.className = 'article-toc__title';
  title.textContent = 'Table of Contents';

  const list = document.createElement('ul');
  list.className = 'article-toc__list';

  headings.forEach(function (heading) {
    const item = document.createElement('li');
    const button = document.createElement('button');

    item.className = [
      'article-toc__item',
      heading.tagName === 'H3'
        ? 'article-toc__item--h3'
        : 'article-toc__item--h2'
    ].join(' ');

    button.type = 'button';
    button.className = 'article-toc__link';
    button.textContent = heading.textContent.trim();

    button.addEventListener('click', function () {
      // 不通过 ID，直接滚动到对应的标题元素
      heading.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });

    item.appendChild(button);
    list.appendChild(item);
  });

  toc.appendChild(title);
  toc.appendChild(list);

  // 将目录插入文章内容之前
  article.parentNode.insertBefore(toc, article);

  // 给标题预留固定导航栏空间
  headings.forEach(function (heading) {
    heading.style.scrollMarginTop = '100px';
  });

  // 注入目录样式
  if (!document.getElementById('article-toc-styles')) {
    const style = document.createElement('style');
    style.id = 'article-toc-styles';
    style.textContent = `
    .article-toc {
      margin: 0 0 32px;
      padding: 16px 18px;
      border: 1px solid var(--border-color);
      border-radius: 3px;
      background: #fff;
    }

    .article-toc__title {
      margin-bottom: 6px;
      color: var(--heading-color);
      font-size: 22px;
      font-weight: 700;
      line-height: 1.3;
    }

    .article-toc__list {
      margin: 0;
      padding: 0;
      list-style: none;
    }

    .article-toc__item {
      position: relative;
      margin: 4px 0;
      padding-left: 16px;
    }

    .article-toc__item::before {
      content: "";
      position: absolute;
      top: 0.72em;
      left: 0;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: var(--accent-color);
      transform: translateY(-50%);
    }

    .article-toc__item--h3 {
      margin-left: 25px;
    }

    .article-toc__link {
      display: inline;
      padding: 0;
      border: 0;
      background: none;
      color: var(--text-color);
      font: inherit;
      font-weight: 600;
      line-height: 1.45;
      text-align: left;
      cursor: pointer;
    }

    .article-toc__item--h3 .article-toc__link {
      font-weight: 500;
    }

    .article-toc__link:hover,
    .article-toc__link:focus-visible {
      color: var(--accent-color);
      background-color: transparent;
      text-decoration: underline;
    }

    @media (max-width: 749px) {
      .article-toc {
        padding: 14px;
      }

      .article-toc__title {
        font-size: 19px;
      }

      .article-toc__item--h3 {
        margin-left: 16px;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      html {
        scroll-behavior: auto;
      }
    }
  `;

    document.head.appendChild(style);
  }
});